import Vue from 'vue'
import { MutationTree } from 'vuex'
import { IAdminState, IAdminInfo } from './types'

const mutations: MutationTree<IAdminState> = {
  SET_ADMIN_LIST (state, payload: IAdminInfo) {
    Vue.set(state, 'adminList', payload)
  }
}

export default mutations
